//router
import { Link } from "react-router-dom";
//styled
import styled from "styled-components";
//animations
import { motion } from "framer-motion";
import { AnimPage, fade, animPhoto, animLine } from "../Animation";

export default function Programs() {
	return (
		<Program variants={AnimPage} exit="exit" initial="hidden" animate="show">
			{/* plan-1 */}
			<Plan>
				<motion.h2 variants={fade}>Group Training</motion.h2>
				<motion.div variants={animLine}  className="line"></motion.div>
				<Hide>
					<motion.img initial="hidden"  animate="show"
						variants={animPhoto}
						src="https://images.pexels.com/photos/3776144/pexels-photo-3776144.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
						alt="group-train"
					/>
				</Hide>

				<StyledLink to="/programs/work1">
					<button>View more</button>
				</StyledLink>
			</Plan>
			{/* plan-2 */}
			<Plan>
				<h2>Freestyle Training</h2>
				<div className="line"></div>

				<img
					src="https://wallpapercave.com/wp/wp4595630.jpg"
					alt="group-train"
				/>

				<StyledLink to="/programs/work2">
					<button>View more</button>
				</StyledLink>
			</Plan>
			{/* plan-3 */}
			<Plan>
				<h2>Cardio Training</h2>
				<div className="line"></div>

				<img
					src="https://images.pexels.com/photos/3757954/pexels-photo-3757954.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
					alt="group-train"
				/>
				<StyledLink to="/programs/work3">
					<button>View more</button>
				</StyledLink>
			</Plan>
			{/* plan-4 */}
			<Plan>
				<h2>Strength Training</h2>
				<div className="line"></div>

				<img
					src="https://images.unsplash.com/photo-1532384748853-8f54a8f476e2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"
					alt="group-train"
				/>

				<StyledLink to="/programs/work4">
					<button>View more</button>
				</StyledLink>
			</Plan>
			{/* plan-5 */}
			<Plan>
				<h2>Personal Training</h2>
				<div className="line"></div>

				<img
					src="https://www.deabyday.tv/.imaging/default/article/articles/fit/question/Addominali--qual---la-differenza-tra-crunch-e-sit-up-/imageOriginal.jpg"
					alt="group-train"
				/>

				<StyledLink to="/programs/work5">
					<button>View more</button>
				</StyledLink>
			</Plan>
		</Program>
	);
}

const Program = styled(motion.div)`
	min-height: 100vh;
	overflow: hidden;
	padding: 5rem 10rem;
	h2 {
		padding: 1rem 0rem;
		color: #fff;
	}
	@media(max-width: 1300px){
		padding: 2rem 2rem;
		h2{
			font-size: 3rem;
		}
	}
`;
const StyledLink = styled(Link)`
	text-decoration: none;
`;

const Plan = styled.div`

@media (max-width: 1300px){
	img{
		height: 50vh;
		margin-bottom: 1rem;
		
	}
}

	padding-bottom: 10rem;
	.line {
		height: 0.5rem;
		background: #cccccc;
		margin-bottom: 3rem;
	}
	img {
		width: 100%;
		object-fit: cover;
	}

`;

const Hide = styled.div`
	overflow: hidden;
`;

